import { Component, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { loadToggleSidenav } from '@serasa/core/modules/users/state/actions/user.actions';
import { SidenavManagerService } from '@serasa/shared/services/sidenav.manager.service';
import { SedsModalService, SedsPositionsOptions } from 'experian-design-system';
import { CustomUserModalComponent } from '../custom-user-modal/custom-user-modal.component';

@Component({
    selector: 'pl-add-user',
    templateUrl: './add-user.component.html',
    styleUrls: ['./add-user.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AddUserComponent {
  iconPositionRight = SedsPositionsOptions.RIGHT;
  iconName = 'expand_more';

  constructor(
    private readonly store: Store,
    private readonly _sidenavManagerService: SidenavManagerService,
    private modalService: SedsModalService
  ) {}

  public add(): void {
    this._openSidenav();
    this._sidenavManagerService.navigate$.next('add');
  }

  public openCustomUserModal(): void {
    const options = {
      maxWidth: '458px',
      position: { top: '25.2vh' },
    };

    this.modalService.open(CustomUserModalComponent, null, options);
  }

  private _openSidenav(): void {
    this.store.dispatch(
      loadToggleSidenav({
        openSidenav: true,
      })
    );
  }
}
